
import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withWidth from '@material-ui/core/withWidth';
import { withStyles } from '@material-ui/core/styles';
import ReactPlayer from 'react-player';
import Grid from '@material-ui/core/Grid';
import NewsItemParts from '/components/newsItemParts';
import SponsorFeatureBadge from '/components/sponsorFeatureBadge';
import ForwardButton from './ForwardButton';
import Icon from '@material-ui/core/Icon';
import ReactJWPlayer from 'react-jw-player';
import { isMobile } from "react-device-detect";
import WidgetJwPlaylistPlayer from '/components/widgetJwPlaylistPlayer';
import ClapprPlayer from '/components/Clappr/ClapprPlayer';

const styles = (theme) => ({
    root: {
        width: '100%',
    },
    layout: {
      margin: '-3px auto -3px',
    },
    reactPlayer:{
      position: 'absolute',
      top: 0,
      left: 0,
    },
    playerWrapper: {
      // position: 'relative', (for full video poster in wrapper)
      width: '70%',
      height: 'inherit',
      margin: '0 auto',
      [theme.breakpoints.only('xs')]: {
        width: '100%'
      },
    },
    forwordBtnAndBadgeWrapper:{
      position: 'absolute',
      top: -3,
      zIndex: 1,
      left: -8
    },
    closeIconWrapper: {
      width: 34, 
      height: 34, 
      position: 'absolute', 
      top: 0, 
      right: 0, 
      zIndex: 3, 
      cursor: 'pointer',
      borderRadius: '0px 0px 0px 32px'
    },
    closeIcon: {
      background: '#212121', 
      color: '#fff', 
      position: 'absolute', 
      right: 0
    }
});

class ArticleDetailVideo extends React.Component{

  close = () => {
    let articleVideo = document.getElementById("articleYoutubeCard")
    articleVideo.style.display = 'none'
  }
  render(){
    const { classes, item, video, isServer} = this.props;
    const envPlayer = process.env.ARTICLE_SECTION_PLAYER && process.env.ARTICLE_SECTION_PLAYER.toLowerCase(); 
    // customProps = object containing properties to be applied directly to the JW Player instance
    let customProps = null;
    if(video){
      customProps = {
          ga: {
              label: video && video.title ? video.title : 'No Title'
          }
      };
      if ( !video.no_ads ) { 
        if ( video.ad_tag ) // set custom AdTag
          customProps.advertising = { 
            client: "googima",
            tag: video.ad_tag 
          };
      }
      else { //inject empty AdTag
        customProps.advertising = {
          tag: ''
        };
      }
      customProps.floating = !video.ad_tag;                   
    }
    
    return (
      <div className={classes.root}>
        {/* <div className={classes.layout} > */}
            <Grid container
                direction="row" style={{position: 'relative', paddingTop: 48}} >
                <div className={classes.forwordBtnAndBadgeWrapper}>
                  <ForwardButton isServer={isServer} url={this.props.url} />
                  <SponsorFeatureBadge featured={item.featured} sponsored={item.is_sponsor} url={item.path} positionStyle={{left: 45, top: 13, zIndex: 1}} />
                </div>

                <Grid item xs={12} sm={12} md={12} style={{position: 'relative', zIndex: 2}} >
                  <div style={{height: this.props.width === 'xs' || isMobile ? 'calc(100vw * 0.5625)': 445, width: '100%', background: 'rgba(128, 128, 128, 0.11)' }}>
                    {item.type === 'VIDEO_URL'   ?
                      // For react player with youtube video
                        item.video_url ?
                          <div className={classes.playerWrapper} id='articleYoutubeCard' >
                            <span id='close' onClick={this.close} className={classes.closeIconWrapper} style={{ display: 'none' }}>
                              <Icon className={classes.closeIcon} >close</Icon>
                            </span>
                            <ReactPlayer
                              url={item.video_url}
                              controls
                              width="100%"
                              height="100%"
                              className={classes.reactPlayer}
                            />
                          </div>
                        :
                        <div style={{textAlign: 'center'}} >
                          <img style={{width: this.props.width === 'xs' ? '100%' : '78%'}}  src="https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/default-video-1000x500.png" alt="Duwun Logo" /> 
                        </div>
                      :  
                      // For jwplayer
                        item.video && video.video_url ? 
                          <div style={{ width: this.props.width === 'xs' ? '100%' : '69.4%', margin: '0 auto' }} id="for-float-position">
                             {   envPlayer === 'jwplayer' ?
                                <WidgetJwPlaylistPlayer 
                                    poster={video.posters.thumb}
                                    source={video.video_url}
                                    currentItem={video}
                                    data={video}
                                    isVideoWidget
                                    customProps={customProps}
                                />
                                :
                                <div className={classes.playerWrapper} id='articleYoutubeCard' >
                                  <span id='close' onClick={this.close} className={classes.closeIconWrapper} style={{ display: 'none' }}>
                                    <Icon className={classes.closeIcon} >close</Icon>
                                  </span>
                                  <ClapprPlayer
                                      id="article-detail-clappr-player"
                                      width="100%"
                                      height={this.props.width === 'xs' || isMobile ? "calc(100vw * 0.5625)": '445px'}
                                      autoPlay
                                      poster={video.posters.thumb}
                                      source={video.video_url}
                                      video={video}
                                      isWidget
                                  />
                                </div>
                              }
                            {/* <ReactJWPlayer
                              playerId={`${video.jwplayer_id}`}
                              playerScript={`https://cdn.jwplayer.com/libraries/${video.jwplayer_id}.js`}
                              playlist={[
                                {
                                  // file: `https://cdn.jwplayer.com/videos/${video.jw_media_id}-${video.jwplayer_id}.m3u8`,
                                  file: `${video.video_url}`,
                                  image: `${video.posters.thumb}`,
                                },
                              ]}
                              isAutoPlay
                              customProps={customProps}
                              // customProps={
                              //   { ga: {} },
                              //   showAds === true && videoAdTag != null ? { advertising: customAd } :
                              //   showAds === true ?  { floating: true } :
                              //   { advertising: emptyAd, floating: true }
                              //  }
                          />   */}
                          </div>
                        :
                        <div style={{textAlign: 'center'}} >
                          <img style={{width: this.props.width === 'xs' ? '100%' : '78%'}} src="https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/default-video-1000x500.png" alt="Duwun Logo" /> 
                        </div>   
                    }
                  </div>
                </Grid>
                <div style={{width: '100%', background: '#fff', padding: 14}}>
                    <NewsItemParts item={item} className='detail' />
                </div>
            </Grid>
        {/* </div> */}
      </div>
    );
      
  }
  componentDidMount(){
    if(document.getElementById("articleYoutubeCard")){
        window.articleYoutubeCardFloated = false;
        let articleVideo = document.getElementById("articleYoutubeCard")
        // let sticky =  document.getElementById("articleYoutubeCard") ? articleVideo.offsetTop : null;
        let closeBtn = document.getElementById("close")
        let forResponsive = this.props.width;
        let type = this.props.item.type;
        
        function forClappr(height){
          let clapprNodes = document.getElementById('article-detail-clappr-player').childNodes; // for clappr video height when float
          if(forResponsive !== 'xs')
          for(let i=0; i < clapprNodes.length; i++) { // for clappr video height when float
            if (clapprNodes[i].nodeName.toLowerCase() == 'div') {
                clapprNodes[i].style.height = height;
            }
          } 
        }
        
        function myFunction() {
            if (forResponsive === 'xs' ? window.pageYOffset > 300 : window.pageYOffset > 700) {
              if(!window.articleYoutubeCardFloated){
                articleVideo.classList.add("floatVideo");
                closeBtn.style.display = 'block';
                window.articleYoutubeCardFloated = true;
                type === 'VIDEO' && document.getElementById('article-detail-clappr-player') ? forClappr('169px') : null;
              }
            } 
            else {
              if(window.articleYoutubeCardFloated){
                articleVideo.classList.remove("floatVideo");
                closeBtn.style.display = 'none'
                articleVideo.style.display = 'block'  
                forResponsive === 'xs' ? (
                  articleVideo.style.top = 0,
                  articleVideo.style.position = 'absolute'
                  ) : null;
                type === 'VIDEO' && document.getElementById('article-detail-clappr-player') ? forClappr(forResponsive === 'xs' || isMobile ? "calc(100vw * 0.5625)": '445px') : null;
                window.articleYoutubeCardFloated = false;
              }
            }
        }
        window.onscroll = function() {myFunction()};
      }
  }
  
}


ArticleDetailVideo.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default compose(withStyles(styles), withWidth())(ArticleDetailVideo);
